<template>
  <div data-perfect-scrollbar>
    <b-skeleton-wrapper :loading="isLoading" v-if="isLoading">
      <template #loading>
        <div class="page-section pb10 student-page">
          <div
            class="container page__container d-flex align-items-center"
            v-if="getLoggedInUser.role !== USER_ROLES.STUDENT"
          >
            <p class="backResult text-50">
              <!-- <router-link v-if="$route.params.backTo" :to="{ name: 'hires' }" style="text-decoration: underline">
                <span class="material-icons icon-18pt text-80">navigate_before</span>Back to Hires
              </router-link>
              <router-link
                v-else-if="$route.params.to === 'app-profile'"
                :to="{ name: 'app-profile' }"
                style="text-decoration: underline"
              >
                <span class="material-icons icon-18pt text-80">navigate_before</span>Back to Application Profile
              </router-link> -->

              <!-- v-else-if="!$route.params.backTo" -->
              <span class="clickable-item" @click.prevent="goBack()" style="text-decoration: underline">
                <span style="font-size: 35px" class="material-icons icon-18pt text-80">navigate_before</span>
              </span>
            </p>
          </div>

          <div
            class="container page__container d-flex flex-column flex-md-row align-items-center text-center text-md-left"
          >
            <b-col md="2">
              <b-skeleton-img height="113px" no-aspect></b-skeleton-img>
            </b-col>
            <div class="flex mb-32pt mb-md-0 mobilemb0">
              <h4 class="mb-0"><b-skeleton width="60%" height="1.5rem"></b-skeleton></h4>
              <p class="d-flex mt-2 mb-3">
                <b-skeleton width="85%"></b-skeleton>
              </p>

              <b-row>
                <b-col>
                  <b-skeleton type="button" width="200px"></b-skeleton>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>

        <div class="container page__container page-section student-card mt-0 pt-0 mb-32pt">
          <div class="card">
            <div class="card-body">
              <div class="d-flex mb-1">
                <div class="flex">
                  <div class="mb-1">
                    <h5 class="card-title fw600"><b-skeleton width="50%"></b-skeleton></h5>
                  </div>

                  <div class="d-flex">
                    <div class="flex">
                      <h6 class="icon-align">
                        <i class="material-icons icon-18pt mr-8pt">location_on</i><b-skeleton width="75%"></b-skeleton>
                      </h6>
                      <h6 class="icon-align">
                        <i class="material-icons icon-18pt mr-8pt">timelapse</i><b-skeleton width="50%"></b-skeleton>
                      </h6>
                      <h6 class="icon-align">
                        <i class="material-icons icon-18pt mr-8pt">access_time</i><b-skeleton width="50%"></b-skeleton>
                      </h6>
                      <h6 class="icon-align">
                        <i class="material-icons icon-18pt mr-8pt">event</i><b-skeleton width="50%"></b-skeleton>
                      </h6>
                    </div>
                  </div>

                  <div></div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="d-flex mb-1">
                <div class="flex">
                  <div class="mb-1">
                    <h5 class="card-title fw600"><b-skeleton width="50%"></b-skeleton></h5>
                  </div>

                  <h6>
                    <b-skeleton width="70%"></b-skeleton>
                    <b-skeleton width="85%"></b-skeleton>
                    <b-skeleton width="60%"></b-skeleton>
                  </h6>

                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-skeleton-wrapper>

    <div v-else>
      <div class="page-section pb10 student-page">
        <div
          class="container page__container d-flex align-items-center"
          v-if="getLoggedInUser.role !== USER_ROLES.STUDENT"
        >
          <p class="backResult text-50">
            <!-- <router-link v-if="$route.params.backTo" :to="{ name: 'hires' }" style="text-decoration: underline">
              <span class="material-icons icon-18pt text-80">navigate_before</span>Back to Hires
            </router-link>
            <router-link
              v-else-if="$route.params.to === 'app-profile'"
              :to="{ name: 'app-profile', params: { id: this.$route.params.applicant_id } }"
              style="text-decoration: underline"
            >
              <span class="material-icons icon-18pt text-80">navigate_before</span>Back to Application Profile
            </router-link> -->

            <!-- v-else-if="!$route.params.backTo" -->
            <span class="clickable-item" @click.prevent="goBack()" style="text-decoration: underline">
              <span style="font-size: 35px" class="material-icons icon-18pt text-80">navigate_before</span>
            </span>
          </p>
        </div>
        <div
          class="container page__container d-flex flex-column flex-md-row align-items-center text-center text-md-left"
        >
          <div style="position: relative; width: max-content">
            <img
              style="display: block; object-fit: cover"
              :src="student.user.avatar_url || DefaultAvatar"
              width="115"
              height="115"
              class="mb-32pt mb-md-0 bg-primary rounded mobilemb10"
              :style="student.intro_video_url ? 'opacity: 0.7' : ''"
            />
            <a href="#" @click.prevent="openVideoModal" v-if="student.intro_video_url"
              ><i
                class="fas fa-play fa-3x"
                style="position: absolute; bottom: 10px; left: 40px; right: 10px; top: 40px; color: white"
              ></i
            ></a>
          </div>

          <div class="flex mb-32pt mb-md-0 mobilemb0 ml-3">
            <h4 :class="student.quote || (lastContacted && unlockedStudent) ? 'mb-2' : 'mb-2'">
              {{ student.user.first_name }} {{ student.user.last_name }}
            </h4>
            <a
              :href="`mailto:${student.user.email}`"
              v-if="getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL"
              class="mb-2 text-dark"
              >{{ student.user.email }}</a
            >
            <div>
              <b-badge
                v-if="getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL && !stdEnrollStLoading"
                :variant="get(enrollStatusColor, enrollStatus) || 'primary'"
                class="mt-1 mr-1"
                style="font-size: 0.81rem"
                v-b-popover.hover.top
                title="Enrollment status"
              >
                {{ enrollStatus }}
              </b-badge>
              <b-badge
                :class="
                  'border border-' +
                    (student.is_profile_complete && student.is_profile_visible && student.user.is_active
                      ? `success badge-success`
                      : `danger badge-danger`)
                "
                variant="outlined"
                class="mt-1"
                style="font-size: 0.81rem"
                v-b-popover.hover.top
                :title="
                  student.is_profile_complete && student.is_profile_visible && student.user.is_active
                    ? ``
                    : !student.is_profile_complete && student.is_profile_visible && student.user.is_active
                    ? `This student hasn't on-boarded yet`
                    : (student.is_profile_complete && !student.is_profile_visible && student.user.is_active) ||
                      (!student.is_profile_complete && !student.is_profile_visible && student.user.is_active)
                    ? `The profile of this student is hidden`
                    : `The profile of this student is disabled`
                "
                v-if="getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL"
              >
                {{
                  student.is_profile_complete && student.is_profile_visible && student.user.is_active
                    ? 'Active'
                    : !student.is_profile_complete && student.is_profile_visible && student.user.is_active
                    ? 'Incomplete'
                    : (student.is_profile_complete && !student.is_profile_visible && student.user.is_active) ||
                      (!student.is_profile_complete && !student.is_profile_visible && student.user.is_active)
                    ? 'Hidden'
                    : 'Inactive'
                }}
              </b-badge>
            </div>
            <div>
              <b-dropdown
                text="Profile Actions"
                variant="primary"
                class="my-2"
                v-if="getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL"
              >
                <b-dropdown-item @click.prevent="updateStudent(student)">
                  <md-icon :class="get(student, 'user.is_active') ? 'text-danger  ' : 'text-success'">{{
                    get(student, 'user.is_active') ? 'block' : 'check_circle'
                  }}</md-icon>
                  <span :class="get(student, 'user.is_active') ? 'text-danger  ' : 'text-success'">
                    {{ get(student, 'user.is_active') ? 'Deactivate Profile' : 'Activate Profile' }}
                  </span>
                </b-dropdown-item>

                <b-dropdown-item @click.prevent="hideStudent(student)" v-if="get(student, 'user.is_active')">
                  <md-icon>{{ get(student, 'is_profile_visible') ? 'visibility_off' : 'visibility' }}</md-icon>
                  <span>
                    {{
                      get(student, 'is_profile_visible') && get(student, 'user.is_active')
                        ? 'Hide Profile'
                        : 'Show Profile'
                    }}
                  </span>
                </b-dropdown-item>
                <b-dropdown-item @click.prevent="openCourseAccessModal(student)" v-if="get(student, 'user.is_active')">
                  <md-icon>{{ currentCourseAccessOption(student).icon }}</md-icon>
                  <span> Manage LMS Access </span>
                </b-dropdown-item>
                <b-dropdown-item @click.prevent="openProgramModal(student)">
                  <md-icon>local_library</md-icon>
                  <span> Change Program/Course </span>
                </b-dropdown-item>

                <b-dropdown-item @click.prevent="openCertificatesModal(student)">
                  <md-icon>card_membership</md-icon>
                  <span>Certificates </span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="!get(student, 'is_profile_complete')"
                  :disabled="isResendingInviteEmail"
                  @click.prevent="confirmResendWelcomeEmail(student)"
                >
                  <md-icon>mail_outline</md-icon>
                  <span>Resend Invite Email </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="my-2" v-if="student.quote || (lastContacted && unlockedStudent)">
              <p class="d-flex align-items-center quote text-70 mb-0" v-if="student.quote">"{{ student.quote }}"</p>
              <p v-if="lastContacted && unlockedStudent" class="mb-0">
                <b>Last Contacted:</b> {{ formatDateTime(lastContacted) }}
              </p>
            </div>
            <span v-if="unlockedStudent">
              <a
                href="#"
                class="btn btn-primary mr-2"
                @click.prevent="downloadGivenFile(student.resume_url)"
                v-if="student.resume_url"
                >Resume<span class="material-icons icon-16pt ml-1">file_download</span></a
              >
              <span
                v-b-popover.hover.right
                :title="lastContacted && lastContactedInMonth ? 'You can only contact a student once a month.' : ''"
              >
                <a
                  href="#"
                  data-toggle="modal"
                  data-target="#contact-form"
                  class="btn btn-primary mr-2"
                  :class="isLastContactLoading || (lastContacted && lastContactedInMonth) ? 'disabled' : ''"
                  @click.prevent="viewContactModal"
                  v-if="
                    getLoggedInUser.role !== USER_ROLES.STUDENT && getLoggedInUser.role_type !== USER_ROLE_TYPES.SCHOOL
                  "
                  >Contact
                  <span class="material-icons icon-16pt ml-1">email</span>
                </a>
              </span>

              <router-link
                :to="makeHireRoute"
                data-toggle="modal"
                data-target="#contact-form"
                class="btn btn-primary mr-2"
                :class="isHired ? 'disabled' : ''"
                style="height: 42px"
                v-if="
                  getLoggedInUser.role !== USER_ROLES.STUDENT && getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER
                "
              >
                <span class="material-icons icon-16pt mr-1">work</span>
                <span v-if="isHired">Already Hired</span>
                <span v-else>Hire</span>
              </router-link>
            </span>

            <span v-else-if="getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER">
              <b-skeleton-wrapper :loading="isUnlockStatusLoading">
                <template #loading>
                  <b-skeleton type="button" width="200px"></b-skeleton>
                </template>
                <span v-b-popover.hover.right="showMsg">
                  <b-btn
                    variant="secondary"
                    class="btn-normal"
                    @click.prevent="unlockStudent"
                    style="width: 200px"
                    :disabled="disableUnlock || isUnlockStatusLoading"
                  >
                    <i v-if="isUnlockStatusLoading" class="fas fa-circle-notch fa-spin"></i>
                    <span v-else><i class="material-icons icon-16pt mr-1">lock_open</i> Unlock Candidate</span>
                  </b-btn>
                </span>
              </b-skeleton-wrapper>
            </span>

            <span v-else-if="getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION">
              <b-skeleton-wrapper :loading="isOrgUnlockStatusLoading">
                <template #loading>
                  <b-skeleton type="button" width="200px"></b-skeleton>
                </template>
                <span v-b-popover.hover.right="showOrgMsg">
                  <b-btn
                    variant="secondary"
                    class="btn-normal"
                    @click.prevent="unlockOrgStudent"
                    style="width: 200px"
                    :disabled="disableOrgUnlock || isOrgUnlockStatusLoading"
                  >
                    <i v-if="isOrgUnlockStatusLoading" class="fas fa-circle-notch fa-spin"></i>
                    <span v-else><i class="material-icons icon-16pt mr-1">lock_open</i> Unlock Candidate</span>
                  </b-btn>
                </span>
              </b-skeleton-wrapper>
            </span>
          </div>
        </div>
      </div>
      <div class="container page__container">
        <!-- <div class="scroll-btns" v-if="getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION">
          <button
            class="tabs-nav-btns left-btn"
            @click="scrollTabs('left')"
            :style="{ visibility: showLeftArrow ? 'visible' : 'hidden' }"
          >
            <span style="font-size: 18px; font-weight: bold;" class="material-icons icon-18pt text-80"
              >arrow_back_ios</span
            >
          </button>
          <button
            class="tabs-nav-btns right-btn"
            @click="scrollTabs('right')"
            :style="{ visibility: showRightArrow ? 'visible' : 'hidden' }"
          >
            <span style="font-size: 18px; font-weight: bold;" class="material-icons icon-18pt text-80"
              >arrow_forward_ios</span
            >
          </button>
        </div> -->
        <b-tabs
          ref="std-tabs"
          nav-class="std-segmented-nav"
          content-class=" "
          class="mt-0"
          id="stdProfileTabs"
          style="scroll-margin-top: 66px; font-size: 16.5px"
        >
          <b-tab title="Profile" class="tab-secondary">
            <template #title>
              <i class="fas fa-user align-self-center"></i>
              <strong class="ml-2">Profile</strong>
            </template>

            <student-profile-tab
              :student="student"
              :careerPreferences="careerPreferences"
              :certifications="certifications"
              :showDoc="showDoc"
              :is-school="getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL"
              @view-document="viewDocument"
              @toggle-doc-value="toggleDocValue"
            />
          </b-tab>
          <b-tab
            title="Checklist"
            class="tab-secondary"
            v-if="getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION && student.is_associated"
          >
            <template #title>
              <i class="material-icons align-self-center">list</i>
              <strong class="ml-1">Checklist</strong>
            </template>
            <candidate-checklist :id="get(student, 'id')" />
          </b-tab>

          <b-tab
            title="Skills"
            class="tab-secondary"
            v-if="
              getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER ||
                get(this.getLoggedInUser, 'linked_entity.sch_payment_plan.title') === SCH_PAYMENT_PLANS.PAID_PLAN ||
                (getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION && student.is_associated) ||
                getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL ||
                getLoggedInUser.role === USER_ROLES.STUDENT
            "
          >
            <template #title>
              <i class="material-icons align-self-center">videocam</i>
              <strong class="ml-1">Skills</strong>
            </template>

            <div class="mt-3">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h5 v-if="skills.length" class="mb-0 font-weight-bold">Skills</h5>
                <div class="custom-select-icon">
                  <b-form-select
                    class="custom-select-icon__select"
                    style="min-width: 185px"
                    v-model="filters.skill"
                    :options="skillOptions"
                    @change="onSkillsFilterApplied"
                  ></b-form-select>
                  <span class="material-icons custom-select-icon__icon">sort</span>
                </div>
              </div>
              <hr v-if="skills.length" class="mb-4" />
            </div>

            <div class="mt-3 pt-0">
              <div class="student-card d-flex justify-content-start" v-if="!skills.length && !areSkillsLoading">
                <div class="card card-block card-stretch card-height col-md-12">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-1">
                      <h5 class="card-title fw600">Skills</h5>
                    </div>
                    <i>No Skills Uploaded.</i>
                  </div>
                </div>
              </div>

              <b-skeleton-wrapper :loading="areSkillsLoading" v-else>
                <template #loading>
                  <div class="row">
                    <div class="col-lg-4 col-md-2 col-sm-12" v-for="item in [1, 2, 3, 4]" :key="item">
                      <div class="card card-sm card--elevated p-relative">
                        <span class="js-image">
                          <b-skeleton-img width="100%" class="pb-0 mb-0"></b-skeleton-img>
                        </span>

                        <div class="card-body">
                          <div class="d-flex">
                            <div class="avatar avatar-sm rounded-circle o-hidden" style="border: 1px solid #dfe2e6">
                              <b-skeleton-img class="avatar-img" width="160" height="100%"></b-skeleton-img>
                            </div>
                            <span class="ml-2 w-100">
                              <div class="card-title"><b-skeleton width="100%" /></div>
                              <div class="text-muted"><b-skeleton width="50%"></b-skeleton></div>
                            </span>
                          </div>
                        </div>
                        <div class="card-footer">
                          <div class="row justify-content-end mr-2">
                            <b-skeleton width="20%" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <div v-if="skills.length" class="row card-group-row mb-lg-12pt home-card">
                  <div v-for="skill in skills" :key="skill.id" class="col-lg-4 col-md-4 col-sm-12 clickable-item mb-3">
                    <div class="card card-sm card--elevated p-relative h-100 mb-0">
                      <span
                        class="js-image d-flex justify-content-center clickable-item overlay"
                        data-position="left"
                        :data-height="168"
                        @click.prevent="showSkillDetails(skill.id)"
                      >
                        <img
                          :src="skill.skill_thumbnail_url"
                          alt="cna"
                          class="career-card-img"
                          style="border-top-left-radius: 0.5rem; border-top-right-radius: 0.5rem"
                          v-if="skill.skill_thumbnail_url"
                        />
                        <video
                          :src="skill.skill_video_url"
                          style="border-top-left-radius: 0.5rem; border-top-right-radius: 0.5rem"
                          class="career-card-img"
                          v-else
                        ></video>
                        <div class="d-flex justify-content-end">
                          <md-icon class="text-success mr-2 mt-2" style="position: absolute">{{
                            skill.approval_status === APPROVAL_STATUS.APPROVED ? 'check_circle' : ''
                          }}</md-icon>
                        </div>
                      </span>

                      <div class="card-body" @click.prevent="showSkillDetails(skill.id)">
                        <div class="d-flex">
                          <user-avatar
                            slot="aside"
                            :user="skill.student.user"
                            circle="md"
                            size="md"
                            :file-url="skill.student.user.avatar_url"
                            variant="dark"
                          >
                          </user-avatar>

                          <span class="ml-2">
                            <div class="card-title">
                              {{ skill.student.user.first_name }} {{ skill.student.user.last_name }}
                            </div>
                            <div class="text-muted">{{ skill.title }}</div>
                          </span>
                        </div>
                      </div>
                      <div class="card-footer">
                        <div class="row justify-content-end">
                          <div class="col-auto d-flex align-items-center">
                            <span class="material-icons icon-16pt text-black-50 mr-4pt">access_time</span>
                            <p class="flex text-black-50 lh-1 mb-0">
                              <span>{{ formatTime(skill.created_at) }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-skeleton-wrapper>

              <pagination
                v-if="totalSkills > skills.length"
                v-model="skillsCurrPage"
                :total-rows="totalSkills"
                :per-page="perPage"
                @change="onSkillsPageChange"
                class="mb-3"
              />
            </div>

            <div
              v-if="
                ((getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER ||
                  getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION) &&
                  student.is_associated) ||
                  (getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL &&
                    getLoggedInUser.linked_entity.ai_skills_enabled) ||
                  getLoggedInUser.role === USER_ROLES.STUDENT
              "
              class="mt-5"
            >
              <div v-if="skillCard.length" class="d-flex align-items-center mb-3">
                <h5 class="mb-0 font-weight-bold">Skill Cards</h5>
              </div>
              <hr v-if="skillCard.length" class="mb-4" />

              <div v-if="isSkillCardLoading" class="my-2">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-6" v-for="item in [1, 2, 3]" :key="item">
                    <div class="card card-sm card--elevated p-relative">
                      <span class="js-image">
                        <b-skeleton-img width="100%" class="pb-0 mb-0"></b-skeleton-img>
                      </span>

                      <div class="card-body">
                        <div class="d-flex">
                          <div class="avatar avatar-sm rounded-circle o-hidden" style="border: 1px solid #dfe2e6;">
                            <b-skeleton-img class="avatar-img" width="160" height="100%"></b-skeleton-img>
                          </div>
                          <span class="ml-2 w-100">
                            <div class="card-title"><b-skeleton width="100%" /></div>
                            <div class="text-muted"><b-skeleton width="50%"></b-skeleton></div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else-if="skillCard.length" class="my-2">
                <div class="row card-group-row mb-lg-12pt home-card">
                  <div
                    v-for="card in skillCard"
                    :key="card.id"
                    :id="`skill-${card.id}`"
                    class="col-lg-4 col-md-4 col-sm-6 clickable-item mb-3"
                  >
                    <div
                      style="height: 310px"
                      class="card card-sm card--elevated mb-0 card-flip"
                      :class="{ flipped: flippedCards[card.id] }"
                    >
                      <div class="card-flip-inner">
                        <div class="card-flip-front">
                          <div class="d-flex flex-column justify-content-between" style="height: inherit">
                            <div @click.stop="toggleCardFlip(card.id)">
                              <img
                                :src="
                                  card.image ? card.image : require('@/assets/images/placeholders/default_image.jpeg')
                                "
                                alt="skill demonstration"
                                style="border-top-left-radius: 0.5rem; border-top-right-radius: 0.5rem; height: 250px; object-fit: cover;"
                                class="career-card-img"
                              />
                              <b-btn class="flip-icon"><md-icon class="mr-2">repeat</md-icon>Click to flip</b-btn>
                            </div>

                            <div class="px-2 pb-2 d-flex justify-content-between align-items-center">
                              <div class="d-flex">
                                <user-avatar
                                  slot="aside"
                                  :user="card.student.user"
                                  circle="md"
                                  size="md"
                                  :file-url="card.student.user.avatar_url"
                                  variant="dark"
                                >
                                </user-avatar>

                                <div class="d-flex flex-column ml-2">
                                  <div class="card-title">
                                    {{ card.student.user.first_name }} {{ card.student.user.last_name }}
                                  </div>
                                  <div class="text-muted d-flex align-items-center mt-1">
                                    <div
                                      class="material-icons icon-16pt text-black-50 mr-1"
                                      style="font-size: 14px; vertical-align: middle;"
                                    >
                                      access_time
                                    </div>
                                    <div style="line-height: 1">
                                      {{ formatTime(card.created_at) }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div style="align-self: flex-end;  color:deepskyblue; margin-bottom:-4px">
                                <div class="" v-b-popover.hover.top="'Precision'" v-if="card.precision !== null">
                                  <i class="fas fa-bullseye clickable-item eye-icon mr-1" style="font-size: medium;"></i
                                  >{{ card.precision }}%
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card-flip-back" style="height: 100%;" @click.stop="toggleCardFlip(card.id)">
                          <div class="d-flex flex-column justify-content-center " style="height: 100%;">
                            <h5 class="mb-2 w-100" style="word-break: break-word;">
                              {{ card.skill_map ? card.skill_map.title : 'ai skill card title' }}
                            </h5>
                            <div
                              style="background-color: #dddddd; border-radius: 7px; max-height: 120px; max-width: 260px; overflow-y: auto; font-size: larger; font-weight: bold;"
                              class="px-5 scrollable-content"
                              @wheel.stop="stopParentScroll"
                              @touchmove.stop
                            >
                              {{ card.step ? card.step.step : '' }}
                            </div>
                          </div>

                          <b-btn
                            class="flipped-btn"
                            style="justify-self:end;text-transform: none; margin-bottom: 41px;"
                            @click.stop="toggleCardFlip(card.id)"
                            ><md-icon class="mr-2">repeat</md-icon>Click to flip</b-btn
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="mt-3 pt-0">
                <div class="student-card d-flex justify-content-start">
                  <div class="card card-block card-stretch card-height col-md-12">
                    <div class="card-body">
                      <div class="d-flex align-items-center mb-1">
                        <h5 class="card-title fw600">Skill Cards</h5>
                      </div>
                      <i>No Skill Cards Found.</i>
                    </div>
                  </div>
                </div>
              </div>

              <pagination
                v-if="totalSkillCards > skillCard.length"
                v-model="skillCardCurrentPage"
                :total-rows="totalSkillCards"
                :per-page="perPage"
                @change="fetchSkillCards"
                class="mb-3"
              />
            </div>
          </b-tab>

          <b-tab
            title="Records & Credentials"
            class="tab-secondary"
            v-if="
              getLoggedInUser.role_type !== USER_ROLE_TYPES.STUDENT &&
                getLoggedInUser.role_type !== USER_ROLE_TYPES.ORGANIZATION
            "
          >
            <template #title>
              <i class="fas fa-file align-self-center"></i>
              <strong class="ml-2">Records &amp; Credentials</strong>
            </template>

            <div class="page-section student-card mt-3 pt-0 mb-32pt">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex mb-1">
                    <div class="flex">
                      <div class="d-flex align-items-center mb-1">
                        <h5 class="card-title fw600">Records</h5>
                      </div>

                      <i v-if="!containPIIRecords">No Records Uploaded.</i>

                      <ul v-else>
                        <template v-for="record in recordsKeys">
                          <li :key="record" v-if="get(studentPIIs, record)">
                            <span
                              ><i class="material-icons icon-18pt mr-8pt">check</i>{{ get(piiTitles, record) }}
                              <span
                                v-if="
                                  getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL || studentPIIs[record].expire_at
                                "
                                >-</span
                              >
                              <a
                                href="#"
                                class="text-primary"
                                @click.prevent="openSecModal(get(piiTitles, record), record)"
                                v-if="getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL"
                              >
                                Uploaded at
                                {{ formatDateTime(studentPIIs[record].updated_at) }}
                              </a>
                              <span v-else-if="studentPIIs[record].expire_at">
                                Expires on {{ formatDateSimple(studentPIIs[record].expire_at) }}</span
                              >
                            </span>
                          </li>
                        </template>
                      </ul>

                      <div></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-body">
                  <div class="d-flex mb-1">
                    <div class="flex">
                      <div class="d-flex align-items-center mb-1">
                        <h5 class="card-title fw600">Credentials</h5>
                      </div>

                      <i v-if="!containPIICreds">No Credentials Uploaded.</i>

                      <ul v-else>
                        <template v-for="cred in credentialsKeys">
                          <li :key="cred" v-if="get(studentPIIs, cred)">
                            <span
                              ><i class="material-icons icon-18pt mr-8pt">check</i>{{ get(piiTitles, cred) }}
                              <span
                                v-if="
                                  getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL || studentPIIs[cred].expire_at
                                "
                                >-</span
                              >
                              <a
                                href="#"
                                class="text-primary"
                                @click.prevent="openSecModal(get(piiTitles, cred), cred)"
                                v-if="getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL"
                              >
                                Uploaded at
                                {{ formatDateTime(studentPIIs[cred].updated_at) }}
                              </a>
                              <span v-else-if="studentPIIs[cred].expire_at">
                                Expires on {{ formatDateSimple(studentPIIs[cred].expire_at) }}</span
                              >
                            </span>
                          </li>
                        </template>
                      </ul>

                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab
            title="Interviews"
            class="tab-secondary"
            v-if="
              getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER ||
                getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION
            "
          >
            <template #title>
              <i class="material-icons align-self-center">mic</i>
              <strong class="ml-1">Interviews</strong>
            </template>

            <div v-if="isSubmissionsLoading" class="row my-2">
              <div class="col-md-6" v-for="item in [1, 2]" :key="item">
                <div class="card">
                  <b-skeleton-img width="100%"></b-skeleton-img>

                  <div class="p-2">
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="submissions.length" class="my-2">
              <div class="card mb-0">
                <b-table
                  id="interviews-table"
                  :fields="interviewTableColumns"
                  :items="submissions"
                  head-variant="light"
                  class="table-nowrap"
                  hover
                  responsive
                  no-local-sorting
                  @row-clicked="onInterviewRowClicked"
                >
                  <template #cell(simulation)="data">
                    {{ data.item.simulation.title }}
                  </template>

                  <template #cell(school)="data">
                    {{ get(data.item, 'student.school.name') || '-' }}
                  </template>

                  <template #cell(current_status)="data">
                    {{ data.item.current_status || '-' }}
                  </template>

                  <template #cell(call_duration)="data">
                    {{
                      data.item.call_duration !== null && data.item.call_duration !== undefined
                        ? Math.floor(data.item.call_duration)
                        : '-'
                    }}
                  </template>
                </b-table>
                <div class="card-footer" v-if="totalSubmissions > submissions.length">
                  <pagination
                    v-model="currentPage"
                    :total-rows="totalSubmissions"
                    :per-page="perPage"
                    @change="fetchSubmissions"
                    aria-controls="interviews-table"
                  />
                </div>
              </div>
            </div>

            <div v-else class="mt-3 pt-0">
              <div class="page-section student-card d-flex justify-content-start">
                <div class="card card-block card-stretch card-height col-md-12">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-1">
                      <h5 class="card-title fw600">Interviews</h5>
                    </div>
                    <i>No Interview Found.</i>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>

          <b-tab
            title="certificates"
            class="tab-secondary"
            v-if="
              (getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER ||
                getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION) &&
                student.is_associated
            "
          >
            <template #title>
              <i class="fas fa-file align-self-center"></i>
              <strong class="ml-1">Certificates</strong>
            </template>

            <div v-if="isCertificationsLoading" class="my-2">
              <div v-for="item in [1, 2]" :key="item">
                <div class="card">
                  <div class="p-2">
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="certificates.length" class="my-2">
              <div class="student-card" v-for="certificate in certificates" :key="certificate.id">
                <div class="card">
                  <div class="card-body">
                    <div class="mb-16pt" :class="{ 'd-flex align-items-center': !isMobSmallScreen }">
                      <div class="flex">
                        <div class="d-flex justify-content-between">
                          <div class="title" v-if="certificate.certification_type">
                            {{
                              certificate.certification_type === 'other'
                                ? certificate.certification_other
                                : certificate.certification_type
                            }}
                          </div>
                          <div
                            v-if="certificate.certificate_url"
                            class="d-flex justify-content-end mr-2"
                            style="font-size: 18px;"
                          >
                            <a
                              href="#"
                              @click.prevent="downloadGivenFile(certificate.certificate_url)"
                              v-b-popover.hover.top="'Download'"
                              ><i class="fas fa-download text-primary"></i>
                              <span v-if="!isMobSmallScreen" class="ml-1">Download</span>
                            </a>
                          </div>
                        </div>
                        <h6 class="icon-align" v-if="get(certificate, 'certifying_institution')">
                          <i class="material-icons icon-18pt mr-8pt">school</i>
                          Certified By: {{ get(certificate, 'certifying_institution') }}
                        </h6>
                        <h6 class="icon-align" v-if="get(certificate, 'year_of_certification')">
                          <i class="material-icons icon-18pt mr-8pt">event</i> Year of certification:
                          {{ formatDateTime(get(certificate, 'year_of_certification')) }}
                        </h6>
                        <h6 class="icon-align" v-if="get(certificate, 'expiry_date')">
                          <i class="material-icons icon-18pt mr-8pt">event</i> Expiry Date:
                          {{ formatDateTime(get(certificate, 'expiry_date')) }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="mt-3 pt-0">
              <div class="page-section student-card d-flex justify-content-start">
                <div class="card card-block card-stretch card-height col-md-12">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-1">
                      <h5 class="card-title fw600">Certificates</h5>
                    </div>
                    <i>No Certificates Found.</i>
                  </div>
                </div>
              </div>
            </div>

            <pagination
              v-if="totalCertifications > certificates.length"
              v-model="certificatesCurrentPage"
              :total-rows="totalCertifications"
              :per-page="perPage"
              @change="fetchCertifications"
              class="mb-3"
            />
          </b-tab>

          <b-tab
            title="Exam Results"
            class="tab-secondary"
            v-if="getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION && student.is_associated"
          >
            <template #title>
              <i class="fas fa-clipboard-check align-self-center"></i>
              <strong class="ml-1">Exam Results</strong>
            </template>

            <div v-if="isExamResultsLoading" class="my-2">
              <div v-for="item in [1, 2]" :key="item">
                <div class="card">
                  <div class="p-2">
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="examResults.length" class="my-2">
              <div class="student-card" v-for="result in examResults" :key="result.id">
                <div class="card">
                  <div class="card-body">
                    <div class="mb-16pt" :class="{ 'd-flex align-items-center': !isMobSmallScreen }">
                      <div class="flex">
                        <div class="d-flex justify-content-between">
                          <div class="title">{{ get(result, 'test_provider.name', '—') }}</div>
                          <b-badge
                            variant="none"
                            :class="`border border-${examStatusVariant(result.overall_status)} text-${examStatusVariant(
                              result.overall_status,
                            )}`"
                          >
                            {{ examStatusLabel(result.overall_status) }}
                          </b-badge>
                        </div>
                        <h6 class="icon-align" v-if="get(result, 'test_provider.provider_name')">
                          <i class="material-icons icon-18pt mr-8pt">business</i>
                          Provider: {{ get(result, 'test_provider.provider_name') }}
                        </h6>
                        <h6 class="icon-align" v-if="result.theory_result">
                          <i class="material-icons icon-18pt mr-8pt">menu_book</i>
                          Theory: {{ result.theory_result === 'pass' ? 'Pass' : 'Fail' }}
                          <span v-if="result.theory_date" class="text-muted ml-1">
                            ({{ formatDateTime(result.theory_date) }})
                          </span>
                        </h6>
                        <h6 class="icon-align" v-if="result.skill_result">
                          <i class="material-icons icon-18pt mr-8pt">healing</i>
                          Skills: {{ result.skill_result === 'pass' ? 'Pass' : 'Fail' }}
                          <span v-if="result.skill_date" class="text-muted ml-1">
                            ({{ formatDateTime(result.skill_date) }})
                          </span>
                        </h6>
                        <h6 class="icon-align" v-if="result.clinical_competency_met !== null">
                          <i class="material-icons icon-18pt mr-8pt">assignment_turned_in</i>
                          Clinical Competency: {{ result.clinical_competency_met ? 'Met' : 'Not Met' }}
                        </h6>
                        <h6 class="icon-align" v-if="result.notes">
                          <i class="material-icons icon-18pt mr-8pt">notes</i>
                          {{ result.notes }}
                        </h6>

                        <div v-if="get(result, 'documents.length')" class="mt-2">
                          <a
                            href="#"
                            v-for="doc in result.documents"
                            :key="doc.id"
                            class="mr-3"
                            @click.prevent="downloadGivenFile(doc.file_url)"
                            v-b-popover.hover.top="'Download'"
                          >
                            <i class="fas fa-download text-primary"></i>
                            <span class="ml-1">{{ doc.filename || 'Document' }}</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="mt-3 pt-0">
              <div class="page-section student-card d-flex justify-content-start">
                <div class="card card-block card-stretch card-height col-md-12">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-1">
                      <h5 class="card-title fw600">Exam Results</h5>
                    </div>
                    <i>No Exam Results Found.</i>
                  </div>
                </div>
              </div>
            </div>

            <pagination
              v-if="totalExamResults > examResults.length"
              v-model="examResultsCurrentPage"
              :total-rows="totalExamResults"
              :per-page="perPage"
              @change="fetchExamResults"
              class="mb-3"
            />
          </b-tab>

          <b-tab
            title="Job Offers"
            class="tab-secondary"
            v-if="
              ([USER_ROLE_TYPES.ORGANIZATION].includes(getLoggedInUser.role_type) && student.is_associated) ||
                [USER_ROLE_TYPES.SCHOOL].includes(getLoggedInUser.role_type)
            "
          >
            <template #title>
              <i class="material-icons align-self-center">local_offer</i>
              <strong class="ml-1">Job Offers</strong>
            </template>

            <div v-if="isOffersLoading" class="my-2">
              <div v-for="item in [1, 2]" :key="item">
                <div class="card">
                  <div class="p-2">
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="offers.length" class="my-2">
              <div class="student-card" v-for="offer in offers" :key="offer.id">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div
                        class="title
                     "
                      >
                        {{ get(offer, 'position') }}
                      </div>
                      <div class="d-flex justify-content-end align-items-center mr-2">
                        <div v-if="offer.status">
                          <b-badge
                            :style="{ fontSize: isMobSmallScreen ? '10px' : '15px' }"
                            :class="
                              'border border-' +
                                (offer.status === OFFER_STATUS.APPROVED
                                  ? `success text-success`
                                  : offer.status === OFFER_STATUS.PENDING
                                  ? 'warning text-warning'
                                  : offer.status === OFFER_STATUS.DECLINED
                                  ? `danger text-danger`
                                  : 'black')
                            "
                            variant="none"
                            >{{
                              offer.status === OFFER_STATUS.APPROVED
                                ? 'Approved'
                                : offer.status === OFFER_STATUS.PENDING
                                ? 'Pending'
                                : offer.status === OFFER_STATUS.CANCELLED
                                ? 'Cancelled'
                                : 'Declined'
                            }}</b-badge
                          >
                        </div>
                        <div
                          v-if="offer.offer_letter_url"
                          :style="{ fontSize: isMobSmallScreen ? '15px' : '18px' }"
                          class="ml-2"
                        >
                          <a
                            href="#"
                            @click.prevent="downloadGivenFile(offer.offer_letter_url)"
                            v-b-popover.hover.top="'Download Offer Letter'"
                            ><i class="fas fa-download text-primary"></i>
                            <span v-if="!isMobSmallScreen" class="ml-1">Download</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="mb-16pt" :class="{ 'd-flex align-items-center': !isMobSmallScreen }">
                      <div class="flex">
                        <h6 class="icon-align d-flex align-items-center" v-if="offer.location">
                          <i class="material-icons icon-18pt mr-8pt">location_on</i>{{ offer.location }}
                        </h6>

                        <h6 class="icon-align" v-if="get(offer, 'organization')">
                          <i class="material-icons icon-18pt mr-8pt">school</i>
                          {{ get(offer, 'organization') }} • {{ offer.offer_type }}
                        </h6>
                        <h6 class="icon-align" v-if="get(offer, 'offer_date')">
                          <i class="material-icons icon-18pt mr-8pt">event</i> Offer Date:
                          {{ formatDateSimple(get(offer, 'offer_date')) }}
                        </h6>
                        <h6 class="icon-align" v-if="get(offer, 'start_date')">
                          <i class="material-icons icon-18pt mr-8pt">event</i> Start Date:
                          {{ formatDateSimple(get(offer, 'start_date')) }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="mt-3 pt-0">
              <div class="page-section student-card d-flex justify-content-start">
                <div class="card card-block card-stretch card-height col-md-12">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-1">
                      <h5 class="card-title fw600">Job Offers</h5>
                    </div>
                    <i>No Job Offers Found.</i>
                  </div>
                </div>
              </div>
            </div>

            <pagination
              v-if="totalOffers > offers.length"
              v-model="offersCurrentPage"
              :total-rows="totalOffers"
              :per-page="perPage"
              @change="fetchOffers"
              class="mb-3"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <video-preview-modal
      :showModal="showVideoModal"
      :introVideo="intro_video_url"
      :stdName="get(student, 'user.first_name')"
      @close="hideVideoModal"
    />

    <school-popover
      v-if="getLoggedInUser.role_type !== USER_ROLE_TYPES.SCHOOL && !isLoading"
      :school="student.school"
      :targetId="student.id"
      placement="right"
      :active-std-count="schoolStdCount"
      :std-count-loading="stdCountLoading"
    ></school-popover>

    <document-viewer-modal
      :show-modal="showDocModal"
      :document-title="selectedDocTitle"
      :file-src="selectedDocSrc"
      @close="hideDocViewer"
    ></document-viewer-modal>

    <candidate-contact-modal
      :show-modal="showContactModal"
      :candidate="student"
      @close="hideContactModal"
      @onContact="fetchLastContacted"
      v-if="getLoggedInUser.role !== USER_ROLES.STUDENT"
    ></candidate-contact-modal>

    <secure-doc-modal
      :show-modal="showPIIDocModal"
      :document-title="selectedPIIDocTitle"
      :id="student.id"
      :document-type="selectedPIIDocType"
      @verification="tokenValidation"
      @close="hidePIIViewDocument"
      v-if="getLoggedInUser.role !== USER_ROLES.SCHOOL"
    />
    <security-modal
      :show-modal="showSecurityModal"
      :view-title="viewTitle"
      :view-id="student.id"
      :view-type="viewType"
      @close="hideSecModal"
      @validated="userValidated"
      v-if="getLoggedInUser.role !== USER_ROLES.SCHOOL"
    />

    <program-modal :showModal="showProgramModal" :student="openProgramStudent" @close="hideProgramModal" />
    <certificates-modal
      :showModal="showCertificatesModal"
      :student="certificatesStud"
      @select="onCertificateTypeSelected"
      @close="hideCertificatesModal"
    />
    <transcript-modal :showModal="showTranscriptModal" :student="transcriptStud" @close="hideTranscriptModal" />
    <course-certificate-modal
      :showModal="showCourseCertificateModal"
      :student="courseCertificateStud"
      @close="hideCourseCertificateModal"
    />

    <b-modal
      v-model="showCourseAccessModal"
      title="Manage LMS Access"
      centered
      :ok-disabled="selectedCourseAccess === (get(courseAccessStudent, 'course_access_status') || 'default') || isSavingCourseAccess"
      :ok-title="isSavingCourseAccess ? 'Saving...' : 'Save'"
      cancel-title="Cancel"
      @ok.prevent="saveCourseAccess"
    >
      <p class="text-muted mb-3">Control this student's access to the LMS courses.</p>
      <b-form-group class="mb-0">
        <b-form-radio
          v-for="opt in visibleCourseAccessOptions"
          :key="opt.value"
          v-model="selectedCourseAccess"
          :value="opt.value"
          name="course-access"
          class="mb-3"
        >
          <span class="d-flex align-items-center">
            <md-icon class="mr-2">{{ opt.icon }}</md-icon>
            <span>
              <strong>{{ opt.label }}</strong>
              <small class="d-block text-muted">{{ opt.description }}</small>
            </span>
          </span>
        </b-form-radio>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Page from '@/components/Page.vue';
import { mapActions, mapGetters } from 'vuex';
import {
  formatFullDate,
  getLangOptions,
  getHumanReadableCommaSepStr,
  formatDateTime,
  formatDateSimple,
  formatTime,
  parseFileNameFromUrl,
} from '../../common/utils';
import SchoolPopover from './SchoolPopover/SchoolPopover.vue';
import { get, keyBy, isEmpty, truncate, trim } from 'lodash';
import DefaultAvatar from '@/assets/images/people/user_avatar.png';
import UserAvatar from '@/components/User/UserAvatar.vue';
import DocumentViewerModal from './DocumentViewer/DocumentViewerModal.vue';
import CandidateContactModal from '../EmployerPortal/Students/CandidateContact/CandidateContactModal.vue';

import {
  USER_ROLES,
  USER_ROLE_TYPES,
  FACILITY_TYPES,
  STD_UNLOCK_STATUSES,
  CREDITS_REQUIREMENTS,
  APPROVAL_STATUS,
  SCH_PAYMENT_PLANS,
  OFFER_STATUS,
} from '../../common/constants';
import SecureDocModal from '../SchoolPortal/SecureDocs/SecureDocModal.vue';
import SecurityModal from '../SchoolPortal/SecureDocs/SecurityModal.vue';
import VideoPreviewModal from './VideoPreviewModal.vue';
import ProgramModal from './ProgramModal.vue';
import TranscriptModal from './TranscriptModal.vue';
import CourseCertificateModal from './CourseCertificateModal.vue';
import CertificatesModal from './CertificatesModal.vue';
import StudentProfileTab from './StudentProfileTab.vue';
import Pagination from '@/components/Ui/Pagination.vue';
import CandidateChecklist from './CandidateChecklist/CandidateChecklist.vue';

const EXAM_STATUS_META = {
  not_started: { label: 'Not Started', variant: 'secondary' },
  in_progress: { label: 'In Progress', variant: 'warning' },
  passed: { label: 'Passed', variant: 'success' },
  failed: { label: 'Failed', variant: 'danger' },
};

export default {
  components: {
    CandidateChecklist,
    SchoolPopover,
    DocumentViewerModal,
    CandidateContactModal,
    UserAvatar,
    SecureDocModal,
    SecurityModal,
    VideoPreviewModal,
    Pagination,
    ProgramModal,
    StudentProfileTab,
    TranscriptModal,
    CourseCertificateModal,
    CertificatesModal,
  },
  extends: Page,

  data() {
    return {
      DefaultAvatar,
      SCH_PAYMENT_PLANS,
      OFFER_STATUS,
      USER_ROLES,
      USER_ROLE_TYPES,
      CREDITS_REQUIREMENTS,
      courseAccessOptions: [
        {
          value: 'default',
          label: 'Standard Access',
          icon: 'settings_backup_restore',
          description: 'Grant the student access to courses assigned by the transition admin.',
        },
        {
          value: 'admin_access',
          label: 'Always Allow',
          icon: 'lock_open',
          description: 'Allow the student to log in to the LMS even after the default access period has expired.',
        },
        {
          value: 'admin_restricted',
          label: 'Restrict Access',
          icon: 'lock',
          description: "Revoke the student's access to all assigned courses immediately.",
        },
        {
          value: 'drop_course',
          label: 'Drop From Course',
          icon: 'person_add_disabled',
          description:
            'Unassign the student from their current course and mark the enrolment as dropped. Progress is kept — assigning a course again restores it.',
          requiresActiveEnrollment: true,
        },
      ],
      showCourseAccessModal: false,
      courseAccessStudent: {},
      selectedCourseAccess: 'default',
      isSavingCourseAccess: false,
      isResendingInviteEmail: false,
      title: '',
      studentsListLinkName: '',
      APPROVAL_STATUS,
      isLoading: true,
      isLastContactLoading: true,
      isPIILoading: false,
      student: {},

      // TODO: Check 'Cats Acceptable' Certification.
      certificationTypes: [
        { key: 'cna_license_no', name: 'CNA', downloadable: false, showText: 'Show License' },
        { key: 'cma_license_no', name: 'CMA', downloadable: false, showText: 'Show License' },

        // TODO: Integrate in separate PII tab
        // { key: 'cpr_url', name: 'CPR Certification', downloadable: true },
        // { key: 'first_aid_url', name: 'First Aid Certification', downloadable: true },
        // { key: 'bls_url', name: 'BLS Certification (Life Support)', downloadable: true },
      ],
      recordsTypes: [{ key: 'vehicle_url', name: 'Vehicle Registration', downloadable: true }],
      showDoc: { cna_license_no: false, cma_license_no: false },
      certifications: [],
      records: [],

      skills: [],
      skillsCurrPage: 1,
      totalSkills: 0,

      careerPreferences: [],
      stdCountLoading: true,
      schoolStdCount: 0,
      perPage: 16,
      showDocModal: false,
      selectedDocTitle: '',
      selectedDocSrc: '',
      showContactModal: false,
      langOptions: [],
      FACILITY_TYPES,
      lastContacted: null,
      showProgramModal: false,
      showCertificatesModal: false,
      certificatesStud: null,
      showTranscriptModal: false,
      transcriptStud: null,
      showCourseCertificateModal: false,
      courseCertificateStud: null,
      unlockedStudent: false,
      isUnlockStatusLoading: true,
      isOrgUnlockStatusLoading: false,
      windowWidth: window.innerWidth,
      isSkillCardLoading: false,
      isSkillVideoLoading: false,
      piiTypes: {
        records: [
          { type: 'state_id', name: 'State Id' },
          { type: 'social_sec_card', name: 'Social Security Card' },
          { type: 'tb_test', name: 'TB Test' },
          { type: 'covid_vacc', name: 'COVID-19 Vaccination' },
          { type: 'vehicle_reg', name: 'Vehicle Registration' },
        ],
        credentials: [
          { type: 'cpr', name: 'CPR Licence' },
          { type: 'bls', name: 'Basic Life Support (BLS) Certification' },
          { type: 'first_aid', name: 'First Aid Certification' },
        ],
      },
      recordsKeys: [
        'state_id',
        'social_sec_card',
        'green_card',
        'passport',
        'birth_cert',
        'immunization',
        'tb_test',
        'covid_vacc',
        'vehicle_reg',
        'background_check',
        'student_review',
        'rec_misc_doc_1',
        'rec_misc_doc_2',
        'rec_misc_doc_3',
        'rec_misc_doc_4',
        'rec_misc_doc_5',
        'rec_misc_doc_6',
        'rec_misc_doc_7',
      ],
      credentialsKeys: [
        'cpr',
        'bls',
        'first_aid',
        'completion_cert',
        'school_waiver',
        'ged',
        'cred_misc_doc_1',
        'cred_misc_doc_2',
        'cred_misc_doc_3',
        'cred_misc_doc_4',
        'cred_misc_doc_5',
        'cred_misc_doc_6',
        'cred_misc_doc_7',
      ],
      containPIIRecords: false,
      containPIICreds: false,
      studentPIIs: {},
      piiTitles: {},

      showPIIDocModal: false,
      showSecurityModal: false,
      selectedPIIDocTitle: null,
      selectedPIIDocType: null,

      viewTitle: null,
      viewType: null,
      isTokenExpired: false,
      intro_video_url: null,
      showVideoModal: false,
      areSkillTitlesLoaidng: false,
      skillOptions: [{ value: null, text: 'All Skills' }],
      filters: {
        skill: null,
      },
      empOrgTokens: null,
      isEmpOrgTokensLoading: false,
      isEmpUnlockEnableLoading: false,
      unlock_candidate_enable: false,
      isHired: false,
      openProgramStudent: null,
      submissions: [],
      currentPage: 1,
      totalSubmissions: 0,
      isSubmissionsLoading: true,
      certificates: [],
      isCertificationsLoading: true,
      totalCertifications: 0,
      certificatesCurrentPage: 1,

      examResults: [],
      isExamResultsLoading: true,
      totalExamResults: 0,
      examResultsCurrentPage: 1,
      stdEnrollStLoading: false,
      enrollStatus: '',
      enrollStatusColor: {
        enrolled: 'primary',
        dropped: 'danger',
        completed: 'success',
      },
      offers: [],
      isOffersLoading: true,
      totalOffers: 0,
      offersCurrentPage: 1,
      showLeftArrow: false,
      showRightArrow: true,
      scrollWidth: 0,

      skillCard: [],
      areSkillsLoading: false,
      skillCardCurrentPage: 1,
      totalSkillCards: 0,
      flippedCards: [],
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser', 'getPiiVerificationToken']),
    ...mapGetters('credit', ['getAvailableTokens']),
    visibleCourseAccessOptions() {
      // Dropping is only offered while the enrolment is still active: a `completed`
      // student keeps the status that backs their certificate, and a `dropped` one is
      // already off the course. The backend enforces the same rule.
      const hasActiveEnrollment =
        !!get(this.courseAccessStudent, 'assigned_course.id') &&
        ['enrolled', 'in_progress'].includes(get(this.courseAccessStudent, 'assigned_course_status'));
      return this.courseAccessOptions.filter((opt) => !opt.requiresActiveEnrollment || hasActiveEnrollment);
    },
    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: this.title, active: true },
      ];
    },
    makeHireRoute() {
      let query = {
        school: this.student?.school?.id,
        student: this.student?.id,
      };
      if (this.student.is_associated) {
        query = {
          fromOrganization: true,
          student: this.student?.id,
        };
      }
      return {
        name: 'make-a-hire',
        query,
      };
    },

    disableOrgUnlock() {
      return this.getAvailableTokens < 3;
    },
    calculateTokens() {
      return 3 - this.getAvailableTokens;
    },
    showOrgMsg() {
      return this.disableOrgUnlock ? `You don't have enough tokens to unlock this candidate` : '';
    },
    showMsg() {
      const areTokensAvailable = this.getAvailableTokens < 3 ? false : true;

      const message =
        this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER && !this.unlock_candidate_enable
          ? 'You need to post a job/sponsorship first.'
          : get(this.getLoggedInUser.linked_entity, 'organization') &&
            this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER &&
            !areTokensAvailable &&
            get(this.empOrgTokens, 'allow_emp_deduct') &&
            get(this.empOrgTokens, 'amount_available')
          ? `Your Tokens are lesser than the required tokens. You will be using ${this.calculateTokens} token/s of your organization.`
          : this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER && !areTokensAvailable
          ? 'you have insufficient tokens to unlock this candidate.'
          : `Contact candidate and download resume by unlocking the candidate for ${CREDITS_REQUIREMENTS.UNLOCK_STUDENT} Tokens.`;

      return message;
    },
    disableUnlock() {
      const areTokensAvailable = this.getAvailableTokens < 3 ? false : true;
      return (
        (this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER && !this.unlock_candidate_enable) ||
        (this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER &&
          !areTokensAvailable &&
          ((get(this.empOrgTokens, 'allow_emp_deduct') && !get(this.empOrgTokens, 'amount_available')) ||
            !get(this.empOrgTokens, 'allow_emp_deduct')))
      );
    },
    lastContactedInMonth() {
      if (!this.lastContacted) return false;

      const lastContact = moment(this.lastContacted);
      const diff = moment().diff(lastContact, 'months', true);
      return diff <= 1;
    },

    isMobSmallScreen() {
      return this.windowWidth <= 420;
    },
    interviewTableColumns() {
      return [
        { key: 'simulation', label: 'Interview', tdClass: 'clickable-item' },
        { key: 'school', label: 'School', tdClass: 'clickable-item' },
        { key: 'current_status', label: 'Status', tdClass: 'clickable-item' },
        {
          key: 'created_at',
          label: 'Taken On',
          tdClass: 'clickable-item text-nowrap',
          formatter: value => (value ? formatFullDate(value) : value),
        },
        {
          key: 'call_duration',
          label: 'Duration (Seconds)',
          tdClass: 'clickable-item text-nowrap',
        },
      ];
    },
  },

  methods: {
    ...mapActions('student', [
      'unlockOrgCandidate',
      'getStudent',
      'getMyStudentProfile',
      'getStudentCareerPreference',
      'getStudentLastContacted',
      'getStudentUnlockedStatus',
      'unlockEmpCandidate',
      'getStudentsPIIs',
      'updateStudentProfile',
      'updateStudentHideProfile',
      'updateStudentRestrictCourse',
      'dropStudentCourse',
      'getAllCerts',
      'getAllOffers',
      'getSchStudentsEnrollStatuses',
      'resendStudentWelcomeEmail',
    ]),
    ...mapActions('fileDownload', ['downloadFile']),
    ...mapActions('school', ['getSchoolStudentCounts']),
    ...mapActions('credit', ['getEmployerAvailableTokens', 'updateStateAvailTokens', 'updateStateCredits']),
    ...mapActions('skills', ['getSkills', 'getSkillTitle', 'getSchSkillsConfigs']),
    ...mapActions('organization', ['getEmpOrgCredits', 'getEmpUnlockCandidateEnable']),
    ...mapActions('hire', ['getStudentHireStatus']),
    ...mapActions('simulations', ['getSimulationsSubmissions']),
    ...mapActions('aiSkills', ['getAllSkillMapCards']),
    ...mapActions('examResult', ['getAllExamResults']),

    formatFullDate,
    formatDateTime,
    formatTime,
    formatDateSimple,
    parseFileNameFromUrl,
    get,
    isEmpty,
    truncate,
    trim,
    onInterviewRowClicked(data) {
      this.$router.push(`/simulations/submissions/${data.id}`);
    },
    goBack() {
      this.$router.go(-1);
    },
    scrollTabs(direction) {
      const tabsElement = this.$refs['std-tabs'].$el.querySelector('.nav-tabs');

      const scrollAmount = 200;
      if (direction === 'left') {
        tabsElement.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        this.scrollWidth -= scrollAmount;
      } else if (direction === 'right') {
        tabsElement.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        this.scrollWidth += scrollAmount;
      }
      if (this.scrollWidth <= 0) {
        this.showLeftArrow = false;
      } else {
        this.showLeftArrow = true;
      }
      if (this.scrollWidth >= tabsElement.scrollWidth - tabsElement.clientWidth) {
        this.showRightArrow = false;
      } else {
        this.showRightArrow = true;
      }
    },
    async updateStudent(student) {
      const h = this.$createElement;
      try {
        const isConfirmed = await this.$bvModal.msgBoxConfirm(
          h(
            'div',
            student.user.is_active
              ? `Deactivating profile will revoke student's access to his account.`
              : `Activating profile will grant access to student's account.`,
          ),
          {
            title: 'Are you sure you want to continue?',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          },
        );
        if (isConfirmed) {
          const data = {
            is_active: !student.user.is_active,
          };

          await this.updateStudentProfile({ id: student.id, data });
          this.makeToast({
            variant: 'success',
            msg: student.user.is_active ? 'Profile Deactivated Successfully!' : 'Profile Activated Successfully!',
          });
          this.fetchStudent();
        }
      } catch (error) {
        //
      }
    },
    toggleCardFlip(skillId) {
      this.$set(this.flippedCards, skillId, !this.flippedCards[skillId]);
    },
    async hideStudent(student) {
      const h = this.$createElement;
      try {
        const isConfirmed = await this.$bvModal.msgBoxConfirm(
          h(
            'div',
            student.is_profile_visible
              ? `Hiding profile will make profile hidden to employers but student can still login.`
              : `Show profile will make student profile visible to employers.`,
          ),
          {
            title: 'Are you sure you want to continue?',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          },
        );
        if (isConfirmed) {
          const data = {
            is_profile_visible: !student.is_profile_visible,
          };

          await this.updateStudentHideProfile({ id: student.id, data });
          this.makeToast({
            variant: 'success',
            msg: 'Profile Updated Successfully!',
          });
          this.fetchStudent();
        }
      } catch (error) {
        //
      }
    },
    async confirmResendWelcomeEmail(student) {
      const isConfirmed = await this.$bvModal.msgBoxConfirm(
        `Send the "Join our Student Center!" invite email to ${get(
          student,
          'user.email',
        )}? A new password will be generated for this student and included in the email — their current password will stop working.`,
        {
          title: 'Resend Invite Email',
          size: 'md',
          buttonSize: 'sm',
          okTitle: 'Send',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );
      if (!isConfirmed) return;

      this.isResendingInviteEmail = true;
      try {
        await this.resendStudentWelcomeEmail(student.id);
        this.makeToast({ variant: 'success', msg: 'Invite email sent successfully' });
      } catch (error) {
        this.makeToast({ variant: 'danger', msg: 'Failed to send invite email' });
      }
      this.isResendingInviteEmail = false;
    },
    currentCourseAccessOption(student) {
      const value = get(student, 'course_access_status') || 'default';
      return this.courseAccessOptions.find((opt) => opt.value === value) || this.courseAccessOptions[0];
    },
    openCourseAccessModal(student) {
      this.courseAccessStudent = student;
      this.selectedCourseAccess = get(student, 'course_access_status') || 'default';
      this.showCourseAccessModal = true;
    },
    async confirmDropFromCourse(student) {
      const isConfirmed = await this.$bvModal.msgBoxConfirm(
        `Drop ${get(student, 'user.first_name', 'this student')} from "${get(
          student,
          'assigned_course.title',
          'their course',
        )}"? The enrolment will be marked as dropped and the course will be unassigned, so the student loses access to it. Their progress is kept — assigning the course again restores it.`,
        {
          title: 'Drop From Course',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Drop',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );
      if (!isConfirmed) return;

      this.isSavingCourseAccess = true;
      try {
        await this.dropStudentCourse({ id: student.id });
        this.makeToast({ variant: 'success', msg: 'Student dropped from course' });
        this.showCourseAccessModal = false;
        this.fetchStudent();
      } catch (error) {
        this.makeToast({
          variant: 'danger',
          msg: get(error, 'response.data.message') || 'Failed to drop the student from the course.',
        });
      } finally {
        this.isSavingCourseAccess = false;
      }
    },
    async saveCourseAccess() {
      const student = this.courseAccessStudent;
      if (this.selectedCourseAccess === 'drop_course') {
        await this.confirmDropFromCourse(student);
        return;
      }
      if (!student || this.selectedCourseAccess === (get(student, 'course_access_status') || 'default')) {
        this.showCourseAccessModal = false;
        return;
      }
      this.isSavingCourseAccess = true;
      try {
        await this.updateStudentRestrictCourse({
          id: student.id,
          data: { course_access_status: this.selectedCourseAccess },
        });
        this.makeToast({
          variant: 'success',
          msg: 'Course Access Updated Successfully!',
        });
        this.showCourseAccessModal = false;
        this.fetchStudent();
      } catch (error) {
        this.makeToast({
          variant: 'danger',
          msg: 'Failed to update course access. Please try again.',
        });
      } finally {
        this.isSavingCourseAccess = false;
      }
    },
    async fetchEmpUnlockCandidateEnable() {
      this.isEmpUnlockEnableLoading = true;
      const res = await this.getEmpUnlockCandidateEnable();
      this.unlock_candidate_enable = res.data.unlock_candidate_enable;
      this.isEmpUnlockEnableLoading = false;
    },
    async fetchEmpOrgTokens() {
      this.isEmpOrgTokensLoading = true;
      const res = await this.getEmpOrgCredits({ credits_type: 'tokens' });
      this.empOrgTokens = res.data;
      this.isEmpOrgTokensLoading = false;
    },
    onSkillsFilterApplied() {
      this.fetchSkills();
    },
    async fetchStudentHireStatus() {
      const res = await this.getStudentHireStatus({ student_id: this.$route.params.id });

      this.isHired = res.data.is_hired;
    },
    async fetchSubmissions(pageNum = 1) {
      this.isSubmissionsLoading = true;
      document.getElementById('app').scrollIntoView();

      const response = await this.getSimulationsSubmissions({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        student__id: this.$route.params.id,
      });
      this.submissions = response.data.results;
      this.currentPage = pageNum;
      this.totalSubmissions = response.data.count;
      this.isSubmissionsLoading = false;
    },
    async fetchSkills(pageNum = 1, params = {}) {
      this.areSkillsLoading = true;
      document.getElementById('app').scrollIntoView();
      document.getElementById('app').scrollIntoView();
      try {
        const response = await this.getSkills({
          limit: this.perPage,
          offset: (pageNum - 1) * this.perPage,
          student: this.getLoggedInUser.role === USER_ROLES.STUDENT ? this.student.id : this.$route.params.id,
          title: this.filters.skill,
          ...(this.ordering && { ordering: this.ordering }),
          ...params,
        });

        this.skills = response.data.results;
        this.skillsCurrPage = pageNum;
        this.totalSkills = response.data.count;
        this.pageFromCount = (this.skillsCurrPage - 1) * this.perPage + 1;
        this.pageToCount = this.pageFromCount + get(response.data, 'results.length', 0) - 1;
      } catch (err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.areSkillsLoading = false;
    },

    onSkillsPageChange(pageNum) {
      this.fetchSkills(pageNum);
    },
    // async fetchSkillOptions() {
    //   //    this.areSkillOptsLoading = true;
    //   try {
    //     const response = await this.getSchSkillsConfigs();
    //     this.skillOptions = [{ value: null, title: 'All Skills' }, ...response.data];
    //   } catch (err) {
    //     this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
    //   }

    //   this.areSkillOptsLoading = false;
    // },
    async fetchSkillTitle() {
      this.areSkillTitlesLoaidng = true;
      try {
        const resp = (
          await this.getSkillTitle({
            ...([USER_ROLE_TYPES.EMPLOYER, USER_ROLE_TYPES.ORGANIZATION, USER_ROLES.STUDENT].includes(
              this.getLoggedInUser.role_type,
            ) && {
              school: this.student.school.id,
            }),
          })
        ).data;
        if (resp) {
          this.skillOptions = [
            { value: null, text: 'All Skills' },
            ...resp.map(skill => ({ value: skill.title, text: skill.title })),
          ];
        }
      } catch (err) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.areSkillTitlesLoaidng = false;
    },
    showSkillDetails(id) {
      if (this.getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION) {
        this.openVideoModal(false, id);
        return;
      }
      this.$router.push({
        name:
          this.getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL
            ? 'schl-student-skill-detail'
            : this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER
            ? 'emp-candidate-skill-detail'
            : 'student-skill-details',
        params: {
          id,
        },
      });
    },
    openSkillModal() {
      this.showVideoModal = true;
      this.intro_video_url = this.skill.intro_video_url;
    },
    openVideoModal(intro = true, skill_id) {
      this.showVideoModal = true;
      if (intro) {
        this.intro_video_url = this.student.intro_video_url;
      } else {
        const skill = this.skills.filter(skill => skill.id == skill_id);
        if (skill.length) {
          this.intro_video_url = skill[0].skill_video_url;
        }
      }
    },
    hideVideoModal() {
      this.showVideoModal = false;
    },
    openProgramModal(student) {
      this.openProgramStudent = student;

      this.showProgramModal = true;
    },
    openCertificatesModal(student) {
      this.certificatesStud = student;
      this.showCertificatesModal = true;
    },
    hideCertificatesModal() {
      this.showCertificatesModal = false;
    },
    onCertificateTypeSelected(type) {
      const student = this.certificatesStud;
      if (type === 'course') {
        this.openCourseCertificateModal(student);
      } else {
        this.openTranscriptModal(student);
      }
    },
    openTranscriptModal(student) {
      this.transcriptStud = student;
      this.showTranscriptModal = true;
    },
    hideTranscriptModal() {
      this.showTranscriptModal = false;
    },
    openCourseCertificateModal(student) {
      this.courseCertificateStud = student;
      this.showCourseCertificateModal = true;
    },
    hideCourseCertificateModal() {
      this.showCourseCertificateModal = false;
    },
    hideProgramModal(isProgramChanged) {
      this.showProgramModal = false;
      if (isProgramChanged) {
        this.fetchStudent();
      }
    },
    tokenValidation(title, type) {
      this.isTokenExpired = true;
      this.openSecModal(title, type);
    },
    userValidated(title, _id, type) {
      this.isTokenExpired = false;
      this.viewPIIDocument(title, type);
    },
    openSecModal(title, type) {
      if (!this.getPiiVerificationToken || this.isTokenExpired) {
        this.showSecurityModal = true;
        this.viewTitle = title;
        this.viewType = type;
      } else {
        this.viewPIIDocument(title, type);
      }
    },
    hideSecModal() {
      this.isTokenExpired = false;
      this.showSecurityModal = false;
      this.viewTitle = null;
      this.viewType = null;
    },
    viewPIIDocument(title, type) {
      this.selectedPIIDocTitle = title;
      this.selectedPIIDocType = type;
      this.showPIIDocModal = true;
    },
    hidePIIViewDocument() {
      this.showPIIDocModal = false;
      this.selectedPIIDocTitle = null;
      this.selectedPIIDocType = null;
    },

    async fetchLastContacted() {
      this.isLastContactLoading = true;
      const resp = await this.getStudentLastContacted({ student: this.student.id });
      this.lastContacted = get(resp, 'data.created_at', null);
      this.isLastContactLoading = false;
    },

    async fetchSchoolStdCounts() {
      this.stdCountLoading = true;
      const queryData = {
        only_recently_active: false,
        schools: [get(this.student, 'school.id')],
      };
      const resp = await this.getSchoolStudentCounts({
        ...queryData,
      });
      this.schoolStdCount = get(resp[0], 'students_count', 0);

      this.stdCountLoading = false;
    },
    async fetchCareerPreferences() {
      this.isLoading = true;
      const resp = await this.getStudentCareerPreference({ student: this.student.id });
      if (!isEmpty(resp)) {
        this.careerPreferences = resp.career_preferences;
      }
      this.isLoading = false;
    },

    async fetchStudentPIIs() {
      this.isPIILoading = false;
      try {
        const resp = await this.getStudentsPIIs({ student_id: [parseInt(this.$route.params.id)] });
        const piis = get(resp, 'data.0.student_piis', []);
        this.studentPIIs = keyBy(piis, 'type');
        this.piiTitles = get(resp, 'data.0.type_title_dict', {}) || {};
        this.containPIIRecords = this.recordsKeys.some(recordKey => get(this.studentPIIs, recordKey));
        this.containPIICreds = this.credentialsKeys.some(credKey => get(this.studentPIIs, credKey));

        this.isPIILoading = true;
      } catch (error) {
        //
      }
    },

    async fetchStdUnlockedStatus() {
      this.isUnlockStatusLoading = true;
      if (
        this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER ||
        this.getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION
      ) {
        const resp = await this.getStudentUnlockedStatus({ student: this.$route.params.id });
        this.unlockedStudent = get(resp, 'data.status', STD_UNLOCK_STATUSES.LOCKED) === STD_UNLOCK_STATUSES.UNLOCKED;
        if (this.unlockedStudent) {
          this.student['resume_url'] = get(resp, 'data.unlocked_data.resume_url');
        }
      } else {
        this.unlockedStudent = true;
      }
      this.isUnlockStatusLoading = false;
    },
    async unlockOrgStudent() {
      this.isOrgUnlockStatusLoading = true;
      const isConfirmed = await this.$bvModal.msgBoxConfirm(
        `You are about to unlock the candidate for ${CREDITS_REQUIREMENTS.UNLOCK_STUDENT} Tokens. Proceed?`,
        {
          title: 'Are you sure?',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );
      if (isConfirmed) {
        try {
          await this.unlockOrgCandidate({ data: { student: this.$route.params.id } });
          this.unlockedStudent = true;
          this.updateStateAvailTokens();
          this.updateStateCredits();
          this.makeToast({ variant: 'success', msg: 'Candidate successfully unlocked' });
        } catch (e) {
          this.makeToast({
            variant: 'danger',
            msg: 'Cannot unlock candidate. Please try again later or contact admin.',
          });
        }
      }

      this.isOrgUnlockStatusLoading = false;
    },

    async unlockStudent() {
      this.isUnlockStatusLoading = true;

      const isConfirmed = await this.$bvModal.msgBoxConfirm(
        `You are about to unlock the candidate for ${CREDITS_REQUIREMENTS.UNLOCK_STUDENT} Tokens. Proceed?`,
        {
          title: 'Are you sure?',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );
      if (isConfirmed) {
        try {
          const response = await this.getEmployerAvailableTokens();
          const availableTokens = get(response, 'available_tokens', 0);

          if (
            availableTokens >= CREDITS_REQUIREMENTS.UNLOCK_STUDENT ||
            (get(this.empOrgTokens, 'allow_emp_deduct') && get(this.empOrgTokens, 'amount_available'))
          ) {
            const resp = await this.unlockEmpCandidate({ data: { student: this.$route.params.id } });
            this.student['resume_url'] = get(resp, 'data.unlocked_data.resume_url');
            this.unlockedStudent = true;

            this.updateStateAvailTokens();
            this.updateStateCredits();
            this.makeToast({ variant: 'success', msg: 'Candidate successfully unlocked' });
          } else {
            this.makeToast({
              variant: 'danger',
              msg: 'Insufficient tokens. Please purchase more tokens to unlock a candidate.',
            });
          }
        } catch (_err) {
          this.makeToast({
            variant: 'danger',
            msg: 'Cannot unlock candidate. Please make sure you have sufficient tokens available.',
          });
        }
      }

      this.isUnlockStatusLoading = false;
    },
    async fetchStdEnrollStatus() {
      this.stdEnrollStLoading = true;
      const resp = await this.getSchStudentsEnrollStatuses({
        students: [this.student.id],
      });
      this.enrollStatus = get(resp.data[0], `extras__status`) || 'Enrolled';
      this.stdEnrollStLoading = false;
    },
    async fetchStudent() {
      this.isLoading = true;
      try {
        let resp;
        if (this.getLoggedInUser.role === USER_ROLES.STUDENT) {
          resp = await this.getMyStudentProfile(true);
        } else {
          resp = (await this.getStudent(this.$route.params.id)).data;
        }

        // Redirect paused/incomplete/inactive profile to main candidates page.
        if (
          ((!resp.is_profile_visible && this.getLoggedInUser.role !== USER_ROLES.STUDENT) ||
            (!resp.is_profile_complete && this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER) ||
            !resp.user.is_active) &&
          this.getLoggedInUser.role_type !== USER_ROLE_TYPES.SCHOOL
        ) {
          this.$router.push({
            name: this.studentsListLinkName,
            params: {
              ...(this.$route.params.to === 'unlock' && { to: 'unlock' }),
              ...(this.$route.params.to === 'org-unlock' && { to: 'org-unlock' }),
            },
          });
        }

        resp.desired_work_type = getHumanReadableCommaSepStr(
          resp.desired_work_type.map(type => this.$t(`studentWorkTypeOpts.${type}`)),
          'or',
        );
        resp.desired_work_time = getHumanReadableCommaSepStr(
          resp.desired_work_time.map(time => this.$t(`studentWorkTimeOpts.${time}`)),
        );
        resp.desired_work_day = getHumanReadableCommaSepStr(
          resp.desired_work_day.map(day => this.$t(`jobWorkDays.${day}`)),
        );
        const arr = getLangOptions();
        const langPreference = keyBy(arr, 'value');
        resp.lang_preferences = resp.lang_preferences.map(lang => langPreference[lang].name);

        resp.interested_facility_types = resp.interested_facility_types.map(type => this.FACILITY_TYPES[type]);

        this.certificationTypes.forEach(certType => {
          if (resp[certType.key]) {
            this.certifications.push(certType);
          }
        });
        this.recordsTypes.forEach(recordType => {
          if (resp[recordType.key]) {
            this.records.push(recordType);
          }
        });
        resp.grad_date = resp.grad_date ? moment(resp.grad_date).format('MMMM, YYYY') : null;

        this.student = resp;
        if (get(this.student, 'school.id')) {
          this.fetchSchoolStdCounts();
        }
        this.fetchStdUnlockedStatus();
      } catch (_err) {
        this.$router.push({
          name: this.studentsListLinkName,
          params: {
            ...(this.$route.params.to === 'unlock' && { to: 'unlock' }),
            ...(this.$route.params.to === 'org-unlock' && { to: 'org-unlock' }),
          },
        });
      }
      if (this.getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL) {
        this.fetchStdEnrollStatus();
      }
      this.isLoading = false;
    },

    async downloadGivenFile(url) {
      const h = this.$createElement;

      this.makeToast({
        variant: 'primary',
        msg: h('span', [h('i', { class: 'fas fa-download mr-2' }), 'Downloading File']),
        toaster: 'b-toaster-bottom-left',
      });

      await this.downloadFile({ fileUrl: url, removeTimestamp: true });

      this.makeToast({
        variant: 'success',
        msg: h('span', [h('i', { class: 'fas fa-download mr-2' }), 'File Downloaded']),
        toaster: 'b-toaster-bottom-left',
      });
    },

    toggleDocValue(key) {
      this.showDoc[key] = !this.showDoc[key];
    },

    viewDocument(title, src) {
      this.selectedDocTitle = title;
      this.selectedDocSrc = src;
      this.showDocModal = true;
    },

    hideDocViewer() {
      this.showDocModal = false;
      this.selectedDocTitle = '';
      this.selectedDocSrc = '';
    },

    viewContactModal() {
      this.showContactModal = true;
    },

    hideContactModal() {
      this.showContactModal = false;
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    stopParentScroll(event) {
      // Only prevent default if scroll would escape bounds
      const element = event.currentTarget;
      const isAtTop = element.scrollTop === 0;
      const isAtBottom = element.scrollHeight - element.scrollTop === element.clientHeight;

      // If scrolling up at the top or scrolling down at the bottom, prevent bubbling
      if ((event.deltaY < 0 && isAtTop) || (event.deltaY > 0 && isAtBottom)) {
        event.preventDefault();
      }

      // Stop propagation to prevent parent elements from scrolling
      event.stopPropagation();
    },
    async fetchCertifications(pageNum = 1, params = {}) {
      this.isCertificationsLoading = true;
      const response = await this.getAllCerts({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        student: this.student.id,
        ...params,
      });

      this.certificates = response.data.results;
      this.certificatesCurrentPage = pageNum;
      this.totalCertifications = response.data.count;
      this.isCertificationsLoading = false;
    },

    examStatusVariant(status) {
      return get(EXAM_STATUS_META, `${status}.variant`, 'secondary');
    },

    examStatusLabel(status) {
      return get(EXAM_STATUS_META, `${status}.label`, status);
    },

    async fetchExamResults(pageNum = 1, params = {}) {
      this.isExamResultsLoading = true;
      try {
        const response = await this.getAllExamResults({
          limit: this.perPage,
          offset: (pageNum - 1) * this.perPage,
          student: this.student.id,
          ...params,
        });

        this.examResults = get(response, 'data.results', []);
        this.examResultsCurrentPage = pageNum;
        this.totalExamResults = get(response, 'data.count', 0);
      } catch (e) {
        // Orgs only get results for students they are associated with; a 403 here
        // just means there is nothing to show.
        this.examResults = [];
        this.totalExamResults = 0;
      }
      this.isExamResultsLoading = false;
    },

    async fetchOffers(pageNum = 1, params = {}) {
      this.isOffersLoading = true;
      const response = await this.getAllOffers({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        student: this.student.id,
        ...params,
      });

      this.offers = response.data.results;
      this.offersCurrentPage = pageNum;
      this.totalOffers = response.data.count;
      this.isOffersLoading = false;
    },

    async fetchSkillCards(pageNum = 1, params = {}) {
      this.isSkillCardLoading = true;
      const resp = await this.getAllSkillMapCards({
        student__id: this.student.id,
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        ...params,
      });
      this.skillCard = resp.data.results;
      this.skillCardCurrentPage = pageNum;
      this.totalSkillCards = resp.data.count;
      this.isSkillCardLoading = false;
    },
  },

  async mounted() {
    this.enrollStatus = this.$route.params.enrollStatus;
    window.addEventListener('resize', this.handleResize);
    if (this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER) {
      this.fetchEmpUnlockCandidateEnable();
      this.fetchStudentHireStatus();
    }

    if (
      this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER &&
      this.getLoggedInUser.linked_entity.organization
    ) {
      this.fetchEmpOrgTokens();
    }
    if (this.getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL) {
      this.title = 'Student Profile';
      this.studentsListLinkName = 'schl-students-list';
    } else {
      this.title = 'Candidate Profile';
      if (this.getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION) {
        this.studentsListLinkName = 'org-students-list';
      } else {
        this.studentsListLinkName =
          this.$route.params.to === 'unlock'
            ? 'employer-unlocked-candidates-list'
            : this.$route.params.to === 'org-unlock'
            ? 'org-unlock-students-list'
            : 'employer-candidates-list';
      }
    }

    await this.fetchStudent();
    if (this.getLoggedInUser.role_type === USER_ROLE_TYPES.SCHOOL) {
      this.fetchStudentPIIs();
      this.fetchSkillCards();
      this.fetchOffers();
    }
    if (
      this.getLoggedInUser.role_type === USER_ROLE_TYPES.EMPLOYER ||
      this.getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION
    ) {
      this.fetchLastContacted();

      this.fetchStudentPIIs();
      this.fetchCertifications();
      if (this.student.is_associated) {
        this.fetchSkillCards();
        if (this.getLoggedInUser.role_type !== USER_ROLE_TYPES.EMPLOYER) {
          this.fetchOffers();
        }
        if (this.getLoggedInUser.role_type === USER_ROLE_TYPES.ORGANIZATION) {
          this.fetchExamResults();
        }
        if (this.student.school) {
          this.fetchSkillTitle();
          this.fetchSkills();
        }
      }
      this.fetchSubmissions();
    }
    if (this.getLoggedInUser.role === USER_ROLES.STUDENT) {
      this.fetchSkillCards();
      if (this.student.school) {
        this.fetchSkillTitle();
        this.fetchSkills();
      }
    }
    if (get(this.getLoggedInUser, 'linked_entity.sch_payment_plan.title') === SCH_PAYMENT_PLANS.PAID_PLAN) {
      this.fetchSkillTitle();
      this.fetchSkills();
    }
    this.fetchCareerPreferences();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 22px !important;
  font-weight: bolder;
}
/* Tab bar: flat underline tabs. No boxes — the labels sit on a hairline that
   runs the full width and the active tab is marked by a blue rule beneath it. */
#stdProfileTabs ::v-deep .nav {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: stretch;
  gap: 26px;
  /* Flush with the tab content cards below, which align to the page container. */
  margin: 0 0 18px;
  padding: 0;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #e6eaf0;
  border-radius: 0;
  overflow-x: auto;
  overflow-y: hidden;
  list-style: none;
  white-space: nowrap;
}

#stdProfileTabs ::v-deep .nav::-webkit-scrollbar {
  display: none;
}

#stdProfileTabs ::v-deep .nav-item {
  display: flex;
}

#stdProfileTabs ::v-deep .nav-link {
  display: flex;
  align-items: center;
  gap: 8px;
  border: none !important;
  /* Only the active rule is drawn; the transparent edge reserves its space. */
  border-bottom: 2px solid transparent !important;
  border-radius: 0;
  /* Pulls the rule down onto the nav's own hairline so the two sit flush. */
  margin-bottom: -1px;
  padding: 11px 1px 12px;
  font-size: 15px;
  color: #55637a;
  background-color: transparent;
  transition: color 0.15s ease, border-color 0.15s ease;
}

#stdProfileTabs ::v-deep .nav-link strong {
  font-weight: 500;
  /* The ml-1 / ml-2 utilities on the labels predate the gap above. */
  margin-left: 0 !important;
}

#stdProfileTabs ::v-deep .nav-link i {
  color: #8a94a6;
  font-size: 17px;
  transition: color 0.15s ease;
}

#stdProfileTabs ::v-deep .nav-link:not(.active):hover {
  color: #1f2937;
}

#stdProfileTabs ::v-deep .nav-link.active {
  color: #3b86f5;
  border-bottom-color: #3b86f5 !important;
  background-color: transparent;
}

#stdProfileTabs ::v-deep .nav-link.active strong {
  font-weight: 600;
}

#stdProfileTabs ::v-deep .nav-link.active i {
  color: #3b86f5;
}

@media (max-width: 575px) {
  #stdProfileTabs ::v-deep .nav {
    gap: 20px;
  }

  #stdProfileTabs ::v-deep .nav-link {
    font-size: 14px;
  }
}
.scroll-btns {
  display: flex;
  justify-content: space-between;
  margin-bottom: -43px;
}
.tabs-nav-btns {
  position: relative;
  border: none;
  background-color: #fff;
  left: 0px;
  height: 43px;
  color: #c0c0c0;
  z-index: 2;
}
.tabs-nav-btns:hover {
  color: #888;
}
.left-btn {
  padding-right: 0px;
  padding-left: 8px;
}
.right-btn {
  padding-left: 0px;
  padding-right: 5px;
}
.card-flip {
  perspective: 1000px;
  height: 100%;
}

.card-flip-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.card-flip.flipped .card-flip-inner {
  transform: rotateY(180deg);
}

.card-flip-front,
.card-flip-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.card-flip-back {
  transform: rotateY(180deg);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 0.5rem;
}

.card-flip-back h4 {
  margin-bottom: 1rem;
}

.card-flip-back p {
  margin-bottom: 0.75rem;
}

.flip-icon {
  position: absolute;
  bottom: 65px;
  align-self: flex-end;
  justify-self: anchor-center;
  padding: 6px;
  cursor: pointer;
  text-transform: none;
  border: none;
  color: white;
  background-color: rgb(0, 0, 0, 0.5);
  transition: background-color 0.3s;
}
.flip-icon:hover {
  opacity: 1;
  background-color: black;
}
.flipped-btn {
  color: white;
  border: none;
  background-color: rgb(0, 0, 0, 0.7);
  transition: background-color 0.3s;
}
.flipped-btn:hover {
  opacity: 1;
  background-color: black;
}

.scrollable-content {
  background-color: #f1f1f1;
  border-radius: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  padding: 15px;
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 15px;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  /* This is key to prevent scroll bubbling */
  overscroll-behavior: contain;
  scroll-behavior: smooth;
}

@media (max-width: 580px) {
  .title {
    font-size: 16px !important;
  }
  .card-flip-back {
    padding: 1rem;
  }

  .card-body {
    padding: 0.75rem;
  }

  .card-title {
    font-size: 0.9rem;
  }

  .text-muted {
    font-size: 0.8rem;
  }
}
</style>
